<script>
export let user;
</script>

{#if user?.username }
<div class="userbar">
<p>
<a href="{ user?.home_url }">{ user?.username }</a>
&nbsp;&Vert;&nbsp;
<a href="{ user?.logout_url }">logout</a>
</p>
</div>
{/if}

<style>
.userbar { 
    box-sizing: border-box;
    background-color: hsl(221, 15%, 28%);
    color: white; 
    margin: 0px; 
    padding: 0.2em 1em; 
    height: var(--navbar-height);
    font-size: calc((var(--navbar-height) - 0.4em) * 1);
}
.userbar p { 
    margin: 0px; 
    text-align: right;
    height: 100%;
}
.userbar a { 
    color: white; 
    text-decoration: none; 
    border: none;
}
.userbar a:hover { 
    text-decoration: underline; 
}
</style>